module.exports = __webpack_public_path__ + "static/img/Elliot_Yeo_desktop.6132e97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Elliot_Yeo_desktop.jpg
// module id = 6HWY
// module chunks = 0